import { ReduxBaseAction } from '../../domain/redux/ReduxBaseAction';
import { TransactionJsonModel, TransactionSchema } from '../../domain/stream/transaction/TransactionDomains';
import DeploymentModel from '../../domain/stream/model/DeploymentModel';
import { ComponentDependency } from '../../domain/ui/ComponentMetadata';

export type ChannelActions = 'CHANGE_EVENT' | 'CHANGE_EVENT_IS_UPDATE' | 'CLEAR_EVENT' | 'CHANGE_EVENT_DEPENDENCIES' | 'CHANGE_EVENT_DIRTY';

export const changeEvent = (payload: TransactionJsonModel) =>
  ({
    type: 'CHANGE_EVENT',
    payload,
  }) as ReduxBaseAction<TransactionJsonModel | null, ChannelActions>;

export const changeEventIsUpdate = (payload: boolean) =>
  ({
    type: 'CHANGE_EVENT_IS_UPDATE',
    payload,
  }) as ReduxBaseAction<boolean, ChannelActions>;
export const clearEvent = () =>
  ({
    type: 'CLEAR_EVENT',
    payload: void 0,
  }) as ReduxBaseAction<void, ChannelActions>;

export const changeEventDependencies = (payload: ComponentDependency[]) =>
  ({
    type: 'CHANGE_EVENT_DEPENDENCIES',
    payload,
  }) as ReduxBaseAction<ComponentDependency[], ChannelActions>;

export const changeEventDirty = (payload: boolean) =>
  ({
    type: 'CHANGE_EVENT_DIRTY',
    payload,
  }) as ReduxBaseAction<boolean, ChannelActions>;
